import { chunkArrayByRunLength, flatten } from '../../shared';
import { addUtf8Bom } from './encodingUtils';

// Split a CSV string into several CSV strings (if it exceeds a maxEntries count), and return alongside entriesCount
export function chunkCSV(csvString: string, maxEntries: number): [string[], number] {
    const hasCarriageReturn = csvString.indexOf('\r') >= 0;
    const csvLines = csvString.trim().split(hasCarriageReturn ? /\r/ : /\n/);

    const header = csvLines[0];
    const entries = csvLines.slice(1);
    const entryCount = entries.length;

    // Return input CSV if it has fewer entries than the limit
    if (entryCount <= maxEntries) {
        return [[csvString], entryCount];
    }

    // Chunk the entries, reintroduce the headers, recombine to make strings
    return [
        chunkArrayByRunLength(entries, maxEntries).map(c =>
            [header].concat(c).join(hasCarriageReturn ? '\r' : '\n')
        ),
        entryCount,
    ];
}

const quoteCodePoint = 34;
const lineFeedCodePoint = 10;

export const splitCsvBytesToLinesOfBytes = (bytes: Uint8Array) => {
    let insideQuote = false;
    const linesAsBytes = [[]];
    for (let i = 0; i < bytes.length; i++) {
        const codePoint = bytes[i];

        // Toggle whether we are "inside a quote" every time we reach a Quote (") CodePoint.
        if (codePoint === quoteCodePoint) {
            insideQuote = !insideQuote;
        }

        // If we reach an unquoted linefeed, start a new line. Otherwise, append to current line.
        if (!insideQuote && codePoint === lineFeedCodePoint) {
            linesAsBytes.push([]);
        } else {
            linesAsBytes[linesAsBytes.length - 1].push(codePoint);
        }
    }
    return linesAsBytes.filter(line => line.length) as number[][];
};

export function chunkCSVBytes(csvBytes: Uint8Array, maxEntries: number): [number[][], number] {
    const linesAsBytes: number[][] = splitCsvBytesToLinesOfBytes(csvBytes);

    const [header, ...entries] = linesAsBytes;
    const contactCount = entries.length;

    const headerWithBom = addUtf8Bom(header);

    // Take each "chunk" and reintroduce the header, then join the lines with LineFeed codepoints.
    const chunkedCSVBytes = chunkArrayByRunLength(entries, maxEntries).map(chunk => {
        return flatten([headerWithBom].concat(chunk).map(line => line.concat([lineFeedCodePoint])));
    });

    return [chunkedCSVBytes, contactCount];
}
